import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const Header = () => {

    const [show, setShow] = useState('none');
    const [service, setService] = useState('none');
    const [accommodation, setAccommodation] = useState('none');
    const [scholarship, setScholarship] = useState('none');
    const [abroad, setAbroad] = useState('none');
    const [event, setEvent] = useState('none');
    const [oceania, setOceania] = useState('none');
    const [asia, setAsia] = useState('none');
    const [eropa, setEropa] = useState('none');
    const [amerika, setAmerika] = useState('none');
    const [others, setOthers] = useState('none');

    const enableDropDown = () => {
        setShow('block');
    }

    const disableDropDown = () => {
        setShow('none');
    }

    const dropScholarship = () => {
        if (scholarship == 'none') {
            setScholarship('block')
        } else {
            setScholarship('none')
        }
    }

    const dropService = () => {
        if (service == 'none') {
            setService('block')
        } else {
            setService('none')
        }
    }

    const dropAccommodation = () => {
        if (accommodation == 'none') {
            setAccommodation('block')
        } else {
            setAccommodation('none')
        }
    }

    const dropAbroad = () => {
        if (abroad == 'none') {
            setAbroad('block')
        } else {
            setAbroad('none')
        }
    }

    const dropOceania = () => {
        if (oceania == 'none') {
            setOceania('block')
        } else {
            setOceania('none')
        }
    }

    const dropAsia = () => {
        if (asia == 'none') {
            setAsia('block')
        } else {
            setAsia('none')
        }
    }

    const dropEropa = () => {
        if (eropa == 'none') {
            setEropa('block')
        } else {
            setEropa('none')
        }
    }

    const dropAmerika = () => {
        if (amerika == 'none') {
            setAmerika('block')
        } else {
            setAmerika('none')
        }
    }

    const dropEvent = () => {
        if (event == 'none') {
            setEvent('block')
        } else {
            setEvent('none')
        }
    }

    const dropOthers = () => {
        if (others == 'none') {
            setOthers('block')
        } else {
            setOthers('none')
        }
    }

    return (
        <header id="header" className="fixed-top">

            <div className="top-bar">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-8 ">
                            <p className="m-0">
                                <b>
                                    12 Master Class + Gratis Talent Mapping + Disc 10% English
                                    Course
                                </b>
                            </p>
                        </div>
                        <div className="col-12 col-md-4 d-flex justify-content-center">
                            <a href="https://superstudent.niecindonesia.com/" className="btn-starts mt-1 mt-md-0" target="_blank">
                                <b>
                                    Ikuti <span className="text-danger">Starts Class</span>{" "}
                                    Sekarang
                                </b>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container d-flex align-items-center">
                <a href='https://niecindonesia.com/'><img className="logo me-auto" height="32" src="../../assets/img/logo/logo-01.png"></img></a>
                <div className='container'>
                    <div className="row">
                        <div className="col-lg-12">
                            {/* DESKTOP NAVBAR */}
                            <nav id="navbar" className="navbar">
                                <ul>
                                    <li><Link to={`${process.env.PUBLIC_URL}/`}>Beranda</Link></li>
                                    <li className="dropdown"><Link to="#"><span>Program Kami</span> <i className="bi bi-chevron-down"></i></Link>
                                        <ul>
                                            <li className="dropdown"><Link to={`#`}>Scholarship<i className="bi bi-chevron-right"></i> </Link>
                                                <ul>
                                                    <li><a href='https://beasiswaku.id'>Arnantyo Scholarship</a></li>
                                                    <li><a href={`${process.env.PUBLIC_URL}/scholarship`}>University Scholarship</a></li>
                                                </ul>
                                            </li>
                                            {/* <li><a className="active" href={`${process.env.PUBLIC_URL}/artikel`}>News</a></li> */}
                                            <li><a className="active" href='http://internship.niecindonesia.com/'>Internship</a></li>
                                            <li><a className="active" href='http://studytour.niecindonesia.com/'>Study Tour</a></li>
                                            <li><a className="active" href='http://kursusbahasa.niecindonesia.com/'>Kursus Bahasa</a></li>
                                            <li><a className="active" href='http://prioritas.niecindonesia.com/'>Talent Mapping</a></li>
                                            <li><a href={`${process.env.PUBLIC_URL}/merchandise`}>Merchandise</a></li>
                                            <li className="dropdown"><Link to={`#`}>Layanan Lainnya<i className="bi bi-chevron-right"></i> </Link>
                                                <ul>
                                                    <li className="dropdown"><Link to={`/`}>Accomodation <i className="bi bi-chevron-right"></i> </Link>
                                                        <ul>
                                                            <li><a href='https://niec.studentacco.com/' target="_blank">Amber</a></li>
                                                            <li><a href='/accomodation.html' target="_blank">University Living</a></li>
                                                        </ul>
                                                    </li>
                                                    <li><a className="active" href='https://www.qatarairways.com/en-id/Privilege-Club/student-club-join-now.html?promoCode=NIECQR&cid=SMID18710&utm_id=SMID18710&utm_campaign=ID-LSP-FY2526&utm_medium=Social-Media&utm_term=ID-SC-Partnership-NIEC' target="_blank">Qatar Airways</a></li>
                                                    <li><a className="active" href='https://superstudent.niecindonesia.com/simcard/' target="_blank">SIM Card Canada</a></li>
                                                    <li><a className="active" href='https://partner.fintiba.com/niceindonesia' target="_blank">German Blocked Account & Insurance</a></li>
                                                    <li><a className="active" href='https://taxprep.sprintax.com/niec' target="_blank">USA Tax Refund</a></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="dropdown"><Link to={"/"}><span>Pilihan Negara</span> <i className="bi bi-chevron-down"></i></Link>
                                        <ul>
                                            <li className="dropdown"><Link to={`/`}>Oceania <i className="bi bi-chevron-right"></i> </Link>
                                                <ul>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/aus`}>Australia</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/nzl`}>Selandia Baru</Link></li>
                                                </ul>
                                            </li>
                                            <li className="dropdown"><Link to={`/`}>Asia <i className="bi bi-chevron-right"></i> </Link>
                                                <ul>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/idn`}>Indonesia</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/jpn`}>Japan</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/mys`}>Malaysia</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/sgp`}>Singapura</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/kor`}>Korea</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/chn`}>China</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/tur`}>Turkiye</Link></li>
                                                </ul>
                                            </li>
                                            <li className="dropdown"><Link to={`/`}>Eropa <i className="bi bi-chevron-right"></i> </Link>
                                                <ul>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/fla`}>Finlandia</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/fre`}>Prancis</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/ger`}>Jerman</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/hun`}>Hungaria</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/irl`}>Irlandia</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/nld`}>Belanda</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/pol`}>Polandia</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/esp`}>Spanyol</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/che`}>Swiss</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/dnk`}>Denmark</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/gbr`}>United Kingdom</Link></li>
                                                </ul>
                                            </li>
                                            <li className="dropdown"><Link to={`/`}>Amerika <i className="bi bi-chevron-right"></i> </Link>
                                                <ul>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/can`}>Canada</Link></li>
                                                    <li><Link to={`${process.env.PUBLIC_URL}/country/usa`}>USA</Link></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="dropdown"><Link to={"/"}><span>Event</span> <i className="bi bi-chevron-down"></i></Link>
                                        <ul>
                                            <li><a className="active" href='http://edufest.niecindonesia.com/'>World Education Festival</a></li>
                                            <li><a className="active" href='https://infosession.niecindonesia.com/'>Info Session</a></li>
                                            {/* <li><a className="active" href='https://youthdev.niecindonesia.com/' target="_blank">Global Youth</a></li> */}
                                        </ul>
                                    </li>
                                    <li><a href={`${process.env.PUBLIC_URL}/career`}>Karir</a></li>
                                    <li><a href={`${process.env.PUBLIC_URL}/contact_us`}>Kontak Kami</a></li>
                                    <li><a href={`${process.env.PUBLIC_URL}/about`}>About</a></li>
                                </ul>
                                <i className="bi bi-list mobile-nav-toggle" onClick={enableDropDown}></i>
                            </nav>

                            {/* MOBILE NAVBAR */}
                            <nav style={{ display: show }} className='navbar-mobile'>
                                <ul>
                                    <li><Link to={`${process.env.PUBLIC_URL}/`} onClick={disableDropDown}>Beranda</Link></li>
                                    <li className="dropdown"><Link to="#" onClick={dropService}><span>Program Kami</span> <i className="bi bi-chevron-down"></i></Link>
                                        <ul style={{ paddingLeft: '15px', display: service }}>
                                            <li className='disable-dot'><a href={`#`} onClick={dropScholarship}>Scholarship <i className="bi bi-chevron-right"></i> </a>
                                                <ul style={{ paddingLeft: '15px', display: scholarship }}>
                                                    <li className='disable-dot'><a href='https://beasiswaku.id'>Arnantyo Scholarship</a></li>
                                                    <li className='disable-dot'><a href={`${process.env.PUBLIC_URL}/scholarship`}>University Scholarship</a></li>
                                                </ul>
                                            </li>
                                            {/* <li className='disable-dot'><a href={`${process.env.PUBLIC_URL}/artikel`} onClick={disableDropDown}>Artikel</a></li> */}
                                            <li className='disable-dot'><a href='http://internship.niecindonesia.com/' onClick={disableDropDown}>Internship</a></li>
                                            <li className='disable-dot'><a href='http://studytour.niecindonesia.com/' onClick={disableDropDown}>Study Tour</a></li>
                                            <li className='disable-dot'><a href='http://kursusbahasa.niecindonesia.com/' onClick={disableDropDown}>Kursus Bahasa</a></li>
                                            <li className='disable-dot'><a href='http://prioritas.niecindonesia.com/' onClick={disableDropDown}>Tallent Mapping</a></li>
                                            <li className='disable-dot'><a href={`${process.env.PUBLIC_URL}/merchandise`} onClick={disableDropDown}>Merchandise</a></li>
                                            <li className="disable-dot"><a href='#' onClick={dropOthers}>Layanan Lainnya <i className="bi bi-chevron-right"></i> </a>
                                                <ul style={{ paddingLeft: '15px', display: others }}>
                                                    <ul style={{ paddingLeft: '15px', display: others }}>
                                                        <li className="disable-dot"><a href='#' onClick={dropAccommodation}>Accomodation <i className="bi bi-chevron-right"></i> </a>
                                                            <ul style={{ paddingLeft: '15px', display: accommodation }}>
                                                                <li className='disable-dot'><a href='https://niec.studentacco.com/' target="_blank">Amber</a></li>
                                                                <li className='disable-dot'><a href={`${process.env.PUBLIC_URL}/accommodation?provider=uni-living`}>University Living</a></li>
                                                            </ul>
                                                        </li>
                                                        <li className='disable-dot'><a href='https://www.qatarairways.com/en-id/Privilege-Club/student-club-join-now.html?promoCode=NIECQR&cid=SMID18710&utm_id=SMID18710&utm_campaign=ID-LSP-FY2526&utm_medium=Social-Media&utm_term=ID-SC-Partnership-NIEC' target="_blank" onClick={disableDropDown}>Qatar Airways</a></li>
                                                        <li className='disable-dot'><a href='https://superstudent.niecindonesia.com/simcard/' target="_blank" onClick={disableDropDown}>Sim Card Canada</a></li>
                                                        <li className='disable-dot'><a href='https://partner.fintiba.com/niceindonesia' target="_blank">German Blocked Account & Insurance</a></li>
                                                        <li className='disable-dot'><a href='https://taxprep.sprintax.com/niec' target="_blank">USA Tax Refund</a></li>
                                                    </ul>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="dropdown"><Link to={"/"} onClick={dropAbroad}><span>Pilihan Negara</span> <i className="bi bi-chevron-down"></i></Link>
                                        <ul style={{ paddingLeft: '15px', display: abroad }}>
                                            <li className='disable-dot'><Link to={`/`} onClick={dropOceania}>Oceania <i className="bi bi-chevron-down"></i></Link>
                                                <ul style={{ paddingLeft: '15px', display: oceania }}>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/aus`} onClick={disableDropDown}>Australia</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/nzl`} onClick={disableDropDown}>Selandia Baru</Link></li>
                                                </ul>
                                            </li>
                                            <li className='disable-dot'><Link to={`/`} onClick={dropAsia}>Asia <i className="bi bi-chevron-down"></i></Link>
                                                <ul style={{ paddingLeft: '15px', display: asia }}>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/idn`} onClick={disableDropDown}>Indonesia</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/jpn`} onClick={disableDropDown}>Japan</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/mys`} onClick={disableDropDown}>Malaysia</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/sgp`} onClick={disableDropDown}>Singapura</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/kor`} onClick={disableDropDown}>Korea</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/chn`} onClick={disableDropDown}>China</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/tur`} onClick={disableDropDown}>Turkiye</Link></li>
                                                </ul>
                                            </li>
                                            <li className='disable-dot'><Link to={`/`} onClick={dropEropa}>Eropa <i className="bi bi-chevron-down"></i></Link>
                                                <ul style={{ paddingLeft: '15px', display: eropa }}>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/fla`} onClick={disableDropDown}>Finlandia</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/fre`} onClick={disableDropDown}>Prancis</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/ger`} onClick={disableDropDown}>Jerman</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/hun`} onClick={disableDropDown}>Hungaria</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/irl`} onClick={disableDropDown}>Irlandia</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/nld`} onClick={disableDropDown}>Belanda</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/pol`} onClick={disableDropDown}>Polandia</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/esp`} onClick={disableDropDown}>Spanyol</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/che`} onClick={disableDropDown}>Swiss</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/dnk`} onClick={disableDropDown}>Denmark</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/gbr`} onClick={disableDropDown}>United Kingdom</Link></li>
                                                </ul>
                                            </li>
                                            <li className='disable-dot'><Link to={`/`} onClick={dropAmerika}>Amerika <i className="bi bi-chevron-down"></i></Link>
                                                <ul style={{ paddingLeft: '15px', display: amerika }}>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/can`} onClick={disableDropDown}>Canada</Link></li>
                                                    <li className='disable-dot'><Link to={`${process.env.PUBLIC_URL}/country/usa`} onClick={disableDropDown}>USA</Link></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="dropdown"><Link to={"/"} onClick={dropEvent}><span>Event</span> <i className="bi bi-chevron-down"></i></Link>
                                        <ul style={{ paddingLeft: '15px', display: event }}>
                                            <li className='disable-dot'><a href={"http://edufest.niecindonesia.com/"} onClick={disableDropDown}>World Education Festival</a></li>
                                            <li className='disable-dot'><a href={"https://infosession.niecindonesia.com/"} onClick={disableDropDown}>Info Session</a></li>
                                        </ul>
                                    </li>
                                    <li><a href={`${process.env.PUBLIC_URL}/career`} onClick={disableDropDown}>Karir</a></li>
                                    <li><a href={`${process.env.PUBLIC_URL}/contact_us`} onClick={disableDropDown}>Kontak Kami</a></li>
                                    <li><a href={`${process.env.PUBLIC_URL}/about`} onClick={disableDropDown}>About</a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;